<template lang="pug">
  .TikTokVideos
    Header.absoluteHeader
    .botton-actions.ml-4.pl-2
      .d-flex.justify-content-start
        button(@click="goBack" type="button").button-without-styles
          svg(width='20' height='19' viewbox='0 0 20 19' fill='none' xmlns='http://www.w3.org/2000/svg')
            path(d='M9.55301 16.8398L2.26586 9.55269L9.55301 2.26554M3.27796 9.55269L18.0547 9.55269' stroke='#0058A2' stroke-width='3.12307' stroke-linecap='round' stroke-linejoin='round')
    video(
      v-for="(video, index) in videos"
      :key="index"
      :src="video"
      loop
      controls
    ).VideoColmedica
    .boxAttendee(
      v-if="assignTurn"
      @drop="handlerDrop"
      @dragover="handlerDragover"
    )
      h4.text-center.AssignmentTextAttendee Turno asignado:
      h3.text-center.font-weight-bold.ImportantAsignment {{ assignTurn }}
      //- h5.mt-1.text-center.mb-1.ActualAttendee Próximo turno:
      //- h5.text-middle.font-larger {{ actualTurn }}
      h5.mt-1.text-center.mb-1.ActualAttendee Posición en la fila:
      h5.text-middle.font-larger {{ typeof turnsInFront === "number" ? turnsInFront + 1 : "1" }}
    .containerDescTikTok(v-if="showSignal")
      img.containerDescTikTok-img(src="@/assets/handIcon.svg")
      p.containerDescTikTok-text.px-4.pt-3 Desliza hacia arriba para ver más
    b-button(
      v-if="assignTurn"
      variant="bluecolmedica"
      size="sm"
      type="button"
      v-b-modal.cancel-modal).w-100.py-2.mx-1.text-center.buttonTurnero2.mt-3
      span.font-md Cancelar turno
</template>

<script>
import interact from "interactjs";

import Header from "./components/Header";

export default {
  name: "TikTokVideos",

  components: {
    Header
  },

  data: () => ({
    showSignal: true,
    videos: [
      "https://bsix.assets.gobrilliant.com/colmedica/kioskos/1.mp4",
      "https://bsix.assets.gobrilliant.com/colmedica/kioskos/2.mp4",
      "https://bsix.assets.gobrilliant.com/colmedica/kioskos/3.mp4"

      // "https://bsix.assets.gobrilliant.com/colmedica/oficinavirtual-videos/ansiedad_1.mov",
      // "https://bsix.assets.gobrilliant.com/colmedica/oficinavirtual-videos/bronquitis_2.mov",
      // "https://bsix.assets.gobrilliant.com/colmedica/oficinavirtual-videos/salud_3.mov",


      // "https://bsix.assets.gobrilliant.com/colmedica/oficinavirtual-videos/tiktokparanodeportistass_1.mp4",
      // "https://bsix.assets.gobrilliant.com/colmedica/oficinavirtual-videos/tiktokritmodesuenoo_2.mp4",
      // "https://bsix.assets.gobrilliant.com/colmedica/oficinavirtual-videos/tiktokbruxissmo_3.mp4",
      // "https://bsix.assets.gobrilliant.com/colmedica/oficinavirtual-videos/tiktoksindromecorazonroto_4.mp4",
      // "https://bsix.assets.gobrilliant.com/colmedica/oficinavirtual-videos/tiktoksingluten_5.mp4"
    ]
  }),

  props: ["actualTurn", "assignTurn", "goBack", "turnsInFront"],

  mounted() {
    const position = { x: 0, y: 0 };
    const boxAttendee = interact(".boxAttendee");

    boxAttendee.draggable({
      listeners: {
        move(event) {
          position.x += event.dx;
          position.y += event.dy;

          event.target.style.transform = `translate(${position.x}px, ${position.y}px)`;
        }
      }
    });

    const timer = setTimeout(() => {
      this.showSignal = false;

      clearTimeout(timer);
    }, 3500);
    const options = {};

    this.observer = new IntersectionObserver(this.handlerObserver, options);

    [...document.querySelectorAll(".VideoColmedica")].map($videoColmedica => {
      this.observer.observe($videoColmedica);
    });
  },

  methods: {
    handlerObserver(entries) {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          entry.target.pause();
        } else {
          [...document.querySelectorAll(".VideoColmedica")].map(
            $videoColmedica => {
              $videoColmedica.pause();
            }
          );
          entry.target.play();
        }
      });
    },
    handlerDrop(event) {
      console.log("Fichero(s) arrastrados", event);
    },
    handlerDragover(ev) {
      console.log("File(s) in drop zone");

      // Prevent default behavior (Prevent file from being opened)
      ev.preventDefault();
    }
  }
};
</script>

<style lang="scss" scoped>
.TikTokVideos {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 10;

  width: 100%;
  height: 100%;

  overflow: auto;
  -ms-scroll-snap-type: y mandatory;
  scroll-snap-type: y mandatory;
  background-color: black;

  .absoluteHeader {
    position: fixed;
    top: 15px;
    left: 50%;
    transform: translateX(-50%);
  }

  .VideoColmedica {
    width: 100%;
    height: 100%;
    scroll-snap-align: center;
  }

  .buttonTurnero2 {
    max-width: 136px;
    padding: 0.25rem !important;

    position: fixed;
    bottom: 36px;
    left: 50%;
    transform: translateX(-50%);

    span {
      font-size: 16px;
    }
  }

  .boxAttendee {
    width: 100%;
    max-width: 150px;
    padding: 0.5rem;

    position: fixed;
    top: 96px;
    right: 32px;
    -ms-touch-action: none;
    touch-action: none;

    border-radius: 15px;
    background: rgba(244, 244, 244, 0.65);
    .ImportantAsignment {
      color: #009fe3;
    }
    .font-larger {
      margin: auto;
      text-align: center;
      font-weight: bold;
      font-size: 14px;
    }
    .AssignmentTextAttendee,
    .ImportantAsignment {
      font-size: 16px;
    }
    .ActualAttendee {
      font-size: 14px;
    }
  }

  .containerDescTikTok {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;

    filter: drop-shadow(0px 28px 36px rgba(0, 0, 0, 1));

    img.containerDescTikTok-img {
      max-width: 142px;
      width: 100%;
    }

    .containerDescTikTok-text {
      color: #f4f4f4;
      text-align: center;
    }
  }
}

.botton-actions {
  position: fixed;
  z-index: 10;
  top: 20px;
  left: 15px;
  margin-left: 0 !important;
}
</style>
